<h1 mat-dialog-title class="no-margin">ASSOCIA {{title.toUpperCase()}}<mat-icon class="close-icon"
    (click)="onNoClick()">close</mat-icon></h1>
<h1 class="istruzioni" *ngIf="data.permission && title == 'competenze'">Per associare le {{title}} trascinale nella
  lista "{{title}} associate"
</h1>
<h1 class="istruzioni" *ngIf="data.permission && title == 'profili'">Per associare i {{title}} trascinali nella lista
  "{{title}} associati"
</h1>

<div class="intestazione"><strong *ngIf="title == 'competenze' && data.isAssemblea != 'gestioneAssemblea'">Area
    professionale: </strong>
  <strong class="noWidth" *ngIf="title != 'competenze' && data.isAssemblea != 'gestioneAssemblea'">Competenza:
    &nbsp;</strong>
  <strong class="noWidth" *ngIf="title == 'competenze' && data.isAssemblea == 'gestioneAssemblea'">Assemblea:
    &nbsp;</strong>
  <span>{{data.area}}</span>
</div>
<div class="intestazione" *ngIf="title == 'competenze' && data.isAssemblea != 'gestioneAssemblea'"><strong>Profilo
    professionale: </strong><span>{{data.profilo}}</span></div>
<div class="dialog-body-overflow">

  <div cdkDropListGroup class="associazioni-row">
    <div class="associazione-competenze-container" *ngIf="data.permission">

      <mat-form-field class="full-width margin-bottom-10">
        <mat-label>Ricerca {{title}}</mat-label>
        <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
        <mat-icon (click)="startSearch()" class="search">search</mat-icon>
      </mat-form-field>
      <mat-icon *ngIf="data.isAssemblea !== 'gestioneAssemblea'" class="pointer_new" (click)="aggiungiCompetenza(title)"
        matTooltip="Aggiungi {{title}}">add</mat-icon>
      <div *ngIf="filteredLista" cdkDropList [cdkDropListData]="filteredLista" class="competenze-list"
        id="listaCompetenze" (cdkDropListDropped)="drop($event)">
        <div class="competenze-box" *ngFor="let item of filteredLista" cdkDrag>
          <div class="icon-container" *ngIf="title == 'competenze'">
            <mat-icon class="pointer" (click)="competenzaDetail(item)"
              matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>

          </div>
          <p style="display:block; width:100%;" *ngIf="title != 'competenze'">
            <span class="primary-details" *ngIf="data.isAssemblea != 'gestioneAssemblea'">{{item.id}} -
              {{item.descrizione}}</span>
            <span class="secondary-details" *ngIf="data.isAssemblea != 'gestioneAssemblea'">
              ({{item.stato.descrizione}})
            </span>
            <span class="primary-details" *ngIf="data.isAssemblea == 'gestioneAssemblea'">{{item.idProposta}} -
              {{item.nomeProfilo}}</span>
            <span class="secondary-details" *ngIf="data.isAssemblea == 'gestioneAssemblea'">
              ({{item.statoProposta.descrizione}})
            </span>
          </p>


          <p style="display:block; width:100%;" *ngIf="title == 'competenze'">
            <span class="primary-details">{{item.descrizione}}</span>
            <span class="secondary-details">
              ({{item.tipologia.descrizione}} - {{item.stato.descrizione}})
            </span>
          </p>




        </div>
      </div>

      <mat-paginator *ngIf="filteredLista" #paginator [pageSize]="25" [length]="data.count" [pageIndex]="0"
        showFirstLastButtons (page)="onPaginateChange($event)"></mat-paginator>

    </div>

      <div class="associazione-arrow-container" *ngIf="data.isAssemblea == 'gestioneAssemblea'">
        <div>
          <button mat-icon-button matTooltip="Associa tutti" (click)="associaTutti()">
            <mat-icon class="green">keyboard_double_arrow_right</mat-icon>
          </button>
        </div>
        <div>
          <button mat-icon-button matTooltip="Disassocia tutti" (click)="disassociaTutti()">
            <mat-icon class="green">keyboard_double_arrow_left</mat-icon>
          </button>
        </div>
      </div>

    <div class="associazione-competenze-container" [ngClass]="{'fullWidth':!data.permission}">

      <mat-form-field class="full-width" [ngClass]="data.isAssemblea !== 'gestioneAssemblea' ? 'margin-bottom-50' : 'margin-bottom-10'">
        <mat-label>Ricerca {{title}} associate</mat-label>
        <input [(ngModel)]="searchTextAssociate" matInput placeholder="Ricerca" (input)="filterListAssociate($event)">
        <mat-icon class="search">search</mat-icon>
      </mat-form-field>
      <div cdkDropList [cdkDropListData]="filteredListaAssociate" class="competenze-list" id="competenzeAssociate"
        (cdkDropListDropped)="drop($event)">
        <div class="competenze-box" *ngFor="let item of filteredListaAssociate" cdkDrag>
          <div class="icon-container" *ngIf="title == 'competenze'">
            <mat-icon class="pointer" (click)="competenzaDetail(item)"
              matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>

          </div>
          <p style="display:block; width:100%;" *ngIf="title != 'competenze'">
            <span class="primary-details" *ngIf="data.isAssemblea != 'gestioneAssemblea'">{{item.id}} -
              {{item.descrizione}}</span>
            <span class="secondary-details" *ngIf="data.isAssemblea != 'gestioneAssemblea'">
              ({{item.stato.descrizione}})
            </span>
            <span class="primary-details" *ngIf="data.isAssemblea == 'gestioneAssemblea'">{{item.idProposta}} -
              {{item.nomeProfilo}}</span>
            <span class="secondary-details" *ngIf="data.isAssemblea == 'gestioneAssemblea'">
              ({{item.statoProposta.descrizione}})
            </span>
          </p>


          <p style="display:block; width:100%;" *ngIf="title == 'competenze'">
            <span class="primary-details">{{item.descrizione}}</span>
            <span class="secondary-details">
              ({{item.tipologia.descrizione}} - {{item.stato.descrizione}})
            </span>
          </p>

        </div>
      </div>
      <div *ngIf="data.isAssemblea == 'gestioneAssemblea'" class="green margin-top-10">Elementi associati: <b>{{ filteredListaAssociate.length }}</b></div>
    </div>
  </div>

</div>

<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="save()" [disabled]="!data.permission">
    <mat-icon>compare_arrows</mat-icon>Salva
  </button>

</div>